import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { View, Text } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import LogoBbucleRoad from '@/assets/icon/logo_bbucle_road.svg';
import { useResponsive } from '../../BbucleRoadScreen/context/ResponsiveContext';
import LoginButton from '../../../components/LoginButton';
export default function ListHeader() {
    const { isDesktop } = useResponsive();
    return (_jsxs(Container, { children: [_jsx(AppBar, { children: _jsxs(AppBarInner, { isDesktop: isDesktop, children: [_jsx(Side, {}), _jsx(LogoBbucleRoad, { width: 94, height: 43 }), _jsx(Side, { align: "flex-end", children: _jsx(LoginButton, { location: "list-header" }) })] }) }), _jsx(DescriptionWrapper, { isDesktop: isDesktop, children: _jsxs(Description, { children: ["\uACF5\uC5F0\uC7A5, \uACBD\uAE30\uC7A5, \uD56B\uD50C\uAE4C\uC9C0 \uD720\uCCB4\uC5B4\uB85C \uAC00\uB294 \uBC95!", _jsx("br", {}), "\uBFCC\uD074\uB85C\uB4DC\uC5D0\uC11C \uB3D9\uC120, \uC2DC\uC57C, \uC811\uADFC\uC131\uC744 \uD55C \uBC88\uC5D0 \uD655\uC778\uD574\uBCF4\uC138\uC694\uD83D\uDE4C"] }) })] }));
}
const Container = styled(View) `
  width: 100%;
`;
const AppBar = styled(View) `
  width: 100%;
  background-color: #b8ff55;
`;
const AppBarInner = styled(View) `
  flex-direction: row;
  align-items: center;
  height: 60px;
  width: 100%;
  max-width: ${({ isDesktop }) => (isDesktop ? '800px' : '100%')};
  align-self: center;
  padding: 0 20px;
`;
const Side = styled(View) `
  flex: 1;
  align-items: ${({ align }) => align !== null && align !== void 0 ? align : 'flex-start'};
`;
const DescriptionWrapper = styled(View) `
  width: 100%;
  max-width: ${({ isDesktop }) => (isDesktop ? '800px' : '100%')};
  align-self: center;
  padding: ${({ isDesktop }) => (isDesktop ? '24px 0 20px' : '24px 20px 0px 20px')};
`;
const Description = styled(Text) `
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 500;
  color: ${color.black};
  line-height: 26px;
  letter-spacing: -0.36px;
`;
